import { render, staticRenderFns } from "./HeaderQuickSearch.vue?vue&type=template&id=2ba806c6"
import script from "./HeaderQuickSearch.vue?vue&type=script&lang=js"
export * from "./HeaderQuickSearch.vue?vue&type=script&lang=js"
import style0 from "./HeaderQuickSearch.vue?vue&type=style&index=0&id=2ba806c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports